'use strict';

import base from '~base';

module.exports = function () {
    base();
    // Custom Start: Make cart product images responsive //
    const target = document.querySelector('.suggestions-wrapper');

    if (target) {
        const observer = new MutationObserver((mutationsList) => {
            if (target.innerHTML.length > 0) {
                if (typeof window.makeCloudinaryImagesResponsive !== 'undefined') {
                    window.makeCloudinaryImagesResponsive();
                }
            }
        });

        observer.observe(target, {
            childList: true,
            subtree: true
        });
    }
    // Custom End: Make suggested product images responsive //
};
